module.exports = __webpack_public_path__ + "img/giftbox_358x320@2x.b0c3db9.jpg";